import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CalendarInfo = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 6H22V5C22 4.448 21.552 4 21 4C20.448 4 20 4.448 20 5V6H12V5C12 4.448 11.552 4 11 4C10.448 4 10 4.448 10 5V6H9C6.243 6 4 8.243 4 11V23C4 25.757 6.243 28 9 28H23C25.757 28 28 25.757 28 23V11C28 8.243 25.757 6 23 6ZM26 23C26 24.654 24.654 26 23 26H9C7.346 26 6 24.654 6 23V11C6 9.346 7.346 8 9 8H10V9C10 9.552 10.448 10 11 10C11.552 10 12 9.552 12 9V8H20V9C20 9.552 20.448 10 21 10C21.552 10 22 9.552 22 9V8H23C24.654 8 26 9.346 26 11V23Z" />
		<path d="M19 22H18V17C18 16.448 17.552 16 17 16H15C14.448 16 14 16.448 14 17C14 17.552 14.448 18 15 18H16V22H15C14.448 22 14 22.448 14 23C14 23.552 14.448 24 15 24H19C19.552 24 20 23.552 20 23C20 22.448 19.552 22 19 22Z" />
		<path d="M18 13C18 13.552 17.552 14 17 14C16.448 14 16 13.552 16 13C16 12.448 16.448 12 17 12C17.552 12 18 12.448 18 13Z" />
	</svg>
);

export default CalendarInfo;
